import Phaser from "phaser";
import profiles from "../../public/assets/config/animation-profiles.json";
import { registerAnimationProfile, type AnimationProfile } from "../animation/AnimationProfile";

export function createAnimations(scene: Phaser.Scene): void {
  for (const profile of Object.values(profiles) as AnimationProfile[]) {
    registerAnimationProfile(scene, profile);
  }
}
